export enum Modality {
	VIRTUAL = 'virtual',
	PRESENCIAL = 'presencial',
}

export const modalityArray = Object.values(Modality);
